import Vue from 'vue'
import Vuex from 'vuex'
import {arrSplice, objectifyArr} from "@/core/codeFunctions";
import {PowerArray} from "@/models/powerArray";
import {User} from "@/models/user";
import {Site} from "@/models/site";
import {Device} from "@/models/device";
import {Employee} from "@/models/employee";
import {endOfDay, isMonday, startOfDay, subDays} from "date-fns";
import {Team} from "@/models/team";
import {StatusMap} from "@/models/statusMap";
import {newReq} from "@/core/request";
import {UserSitePref} from "@/models/userSitePref";
import {Ping} from "@/models/ping";
import {Manual} from "@/models/manualTime";
const EventEmitter = require('events');

Vue.use(Vuex);

const checkAccess = (access, page) => {
    switch (page) {
        case 'users': return access.users;
        case 'devices': return access.setup;
        case 'employees': return access.setup;
        case 'teams': return access.setup;
        case 'classification': return access.classification;
        case 'dashboard': return access.statistics;
        case 'employeeStats': return access.statistics;
        case 'teamStats': return access.statistics;
        case 'appStats': return access.statistics;
        default: return true;
    }
}

const store = new Vuex.Store( {
    state() {
        return {

          liveViewEnabled: false,

            employeeDashboard: {
                show: false,
                hwId: null,
                siteId: null
            },

            curTime: new Date(),
            icons: new Map(),

            userOptionsShown: false,
            signup: false,
            storeEvents: new EventEmitter,
            userId: null,
            curSiteId: null,
            loggedIn: false,

            sites: new PowerArray(),
            users: new PowerArray(),
            devices: new PowerArray(),
            teams: new PowerArray(),
            employees: new PowerArray(),
            statusmaps: new PowerArray(),
            usersiteprefs: new PowerArray(),
            realtimes: new PowerArray(),
            pings: new PowerArray(),
            manuals: new PowerArray(),

            ref: {
                app: {
                    curPage: 'dashboard',
                },
                users: {
                    selected: null,
                    filterStr: null,
                    showAdd: false,
                    tabIndex: 0,
                },
                admin: {
                    tabIndex: 0,
                    invoices: {
                        filterStr: null
                    }
                },
                devices: {
                    selected: null,
                    filterStr: null,
                    tabIndex: 0
                },
                employees: {
                    selectedRange: {
                        title: null,
                        start: subDays(startOfDay(new Date()), isMonday(new Date()) ? 3 : 1),
                        end: subDays(endOfDay(new Date()), isMonday(new Date()) ? 3 : 1)
                    },
                    tabIndex: 0,
                    selected: null,
                    filterStr: null,
                    showAdd: false,
                },
                teams: {
                    selected: null,
                    filterStr: null,
                    showAdd: false,
                },
                classification: {
                    selected: null,
                    filterStr: null,
                    showAdd: false,
                    tabIndex: 0,
                    openOnStartup: null,
                    showCreate: false
                },
                dashboard: {
                    tabIndex: 0,
                    filterStr: null,
                    selectedRange: {
                        start: startOfDay(new Date()),
                        end: startOfDay(new Date()),
                        title: 'Today'
                    },
                    showColumnSelection: false,
                    employeesSelectedColumns: ["employeeName", "teamName", "workTime", "activeTime", "ptt", "utt", "ntt", "ttt", "idleTime", "productivityTarget",],
                    teamsSelectedColumns: ["teamName", "workTime", "activeTime", "ptt", "utt", "ntt", "ttt", "idleTime", "productivityTarget",],
                    appsSelectedColumns: ["appName", "tt", "label", "ttn","tto"]
                },
                employeeStats: {
                    selectedEmployee: null,
                    showCardsSelection: false,
                    selectedCards: ["workTime", "ptt", "utt", "productivityTarget"],
                    showAddLeaveRecord: false
                },
                teamStats: {
                    selectedTeam: null,
                    showCardsSelection: false,
                    selectedCards: ["workTime", "ptt", "utt", "productivityTarget"]
                },

                appStats: {
                    selectedApp: null,
                    showCardsSelection: false,
                    selectedCards: ["tt", "tto", "count"]
                },
                partner: {
                    tabIndex: 0,
                    partners: {
                        showCreatePartner: false,
                        filterStr: null
                    },
                    sites: {
                        filterStr: null
                    },

                },
                approvals: {
                    filterStr: null,
                    tabIndex: 0
                },
                leave: {
                    showAdd: false,
                    leaveDate: new Date(),
                    tabIndex: 0,
                    filterStr: null
                }
            },
            labels: [
                {id: 0, text: "Neutral", icon: "mdi-checkbox-blank-circle-outline", color: "blue", cssColor: '#2196F3'},
                {id: 1, text: "Productive", icon: "mdi-check-circle", color: "green", cssColor: '#4CAF50'},
                {id: 2, text: "Unproductive", icon: "mdi-alert-circle", color: "error", cssColor: '#ff5252'},
                {id: 3, text: "Do Not Track", icon: "mdi-minus-circle", color: "grey"},
            ],
            backPages: [],
            defaultSelections: {
                employeesSelectedColumns: ["employeeName", "teamName", "workTime", "activeTime", "ptt", "utt", "ntt", "ttt", "idleTime", "productivityTarget"],
                teamsSelectedColumns: ["teamName", "workTime", "activeTime", "ptt", "utt", "ntt", "ttt", "idleTime", "productivityTarget"],
                appsSelectedColumns: ["appName", "tt", "label", "ttn","tto"],
                employeeStats: ["workTime", "ptt", "utt", "productivityTarget"],
                teamStats: ["workTime", "ptt", "utt", "productivityTarget"],
                appStats: ["tt", "tto", "count"],
            },
            sortPreference: {
                dashboard: {
                    teams: {
                        by: 'teamName',
                        order: false
                    },
                    employees: {
                        by: 'employeeName',
                        order: false
                    },
                    apps: {
                        by: 'appName',
                        order: false
                    },
                },
                teamStats: {
                    employeeStatistics: {
                        by: 'employeeName',
                        order: false
                    },
                    topApps: {
                        by: 'match',
                        order: false
                    },
                },
                employeeStats: {
                    topApps: {
                        by: 'match',
                        order: false
                    },
                },
                appStats: {
                    topTeams: {
                        by: 'teamName',
                        order: false
                    },
                    topEmployees: {
                        by: 'employeeName',
                        order: false
                    },
                },
            },
            historyPreference: false,
            siteConfig: null,
        }
    },
    mutations: {

        setSiteConfig(state, payload) {
            state.siteConfig = payload;
        },
        // setMailConfig(state, payload) {
        //     state.mailConfig = payload
        // },

        addIcon(state, payload) {
            if (payload.icon)
                state.icons.set(payload.match, payload.icon)
        },

        addBackPage(state, getters) {
            const refState = {
                app: {
                    curPage: state.ref.app.curPage,
                },
                users: {
                    selected: state.ref.users.selected ? state.ref.users.selected._id : null,
                },
                devices: {
                    selected: state.ref.devices.selected ? state.ref.devices.selected._id : null,
                },
                employees: {
                    selected: state.ref.employees.selected ? state.ref.employees.selected._id : null,
                },
                teams: {
                    selected: state.ref.teams.selected ? state.ref.teams.selected._id : null,
                },
                classification: {
                    selected: null,
                },
                dashboard: {
                    tabIndex: state.ref.dashboard.tabIndex,
                },
                employeeStats: {
                    selectedEmployee: state.ref.employeeStats.selectedEmployee,
                },
                teamStats: {
                    selectedTeam: state.ref.teamStats.selectedTeam,
                },
                appStats: {
                    selectedApp: state.ref.appStats.selectedApp,
                },
                admin: {
                    tabIndex: state.ref.admin.tabIndex
                }
            }
            const fn = () => {
                state.ref.app.curPage = refState.app.curPage
                // Dashboard
                state.ref.dashboard.tabIndex = refState.dashboard.tabIndex
                // Users
                const user = refState.users.selected ? getters.usersRef[refState.users.selected] : null
                state.ref.users.selected = user;
                state.ref.users.tabIndex = user ? (user.disabledSiteIds.includes(state.curSiteId)  ? 1 : 0) : 0;
                state.ref.users.filterStr = null;
                state.ref.users.showAdd = false;
                // Devices
                const device = refState.devices.selected ? getters.devicesRef[refState.devices.selected] : null;
                state.ref.devices.selected = device
                state.ref.devices.tabIndex = device ? (!device.employeeId ? 2 : (device.disabled || getters.employeesRef[device.employeeId].disabled ? 1 : 0)) : 0;
                state.ref.devices.filterStr = null;
                // Employees
                const employee = refState.employees.selected ? getters.employeesRef[refState.employees.selected] : null;
                state.ref.employees.selected = employee
                state.ref.employees.tabIndex = employee ? (employee.disabled ? 1 : 0) : 0;
                state.ref.employees.filterStr = null;
                state.ref.employees.showAdd = false;
                // Teams
                const team = refState.teams.selected ? getters.teamsRef[refState.teams.selected] : null;
                state.ref.teams.selected = team
                state.ref.teams.filterStr = null;
                state.ref.teams.showAdd = false;
                // Classification
                state.ref.classification.selected = null;
                state.ref.classification.openOnStartup = null;
                // Employee Stats
                state.ref.employeeStats.selectedEmployee = refState.employeeStats.selectedEmployee
                state.ref.employeeStats.showCardsSelection = false;
                // Team Stats
                state.ref.teamStats.selectedEmployee = refState.teamStats.selectedEmployee
                state.ref.teamStats.showCardsSelection = false;
                // Admin
                state.ref.admin.tabIndex = refState.admin.tabIndex;
            }

            state.backPages.push(fn)
        },

        login(state, payload) {
            state.loggedIn = payload !== false;
            state.userID = payload !== false ? payload : null;
        },

        upsertValues(state, payload) {
            function upsert(stateArr, obj, cls = null) {
                if (typeof obj !== 'object') {
                    for (let i = 0; i < stateArr.length; i++) {
                        if (stateArr[i]._id === obj) {
                            try {
                                stateArr[i].emit('deleted')
                                stateArr.emit('deleted', stateArr[i])
                            } catch (e) {
                                // No Error
                            }
                            stateArr.splice(i, 1);
                        }
                    }
                } else {
                    let added = false;
                    for (const stateVar of stateArr) {
                        if (stateVar._id === obj._id) {
                            // Push An Update Event
                            Object.assign(stateVar, obj)
                            try {
                                stateVar.emit('update', {old: stateVar, new: obj})
                            } catch (e) {
                                // No Error
                            }
                            try {
                                stateArr.emit(obj._id, stateVar)
                            } catch (e) {
                                // No Error
                            }
                            added = true;
                        }
                    }

                    if (!added) {
                        const insertObj = !cls ? obj : new cls(obj)
                        stateArr.push(insertObj)
                        try {
                            stateArr.emit(obj._id, insertObj)
                        } catch (e) {
                            // No Error
                        }
                        try {
                            insertObj.emit('update', {old: insertObj, new: insertObj})
                        } catch (e) {
                            // No Error
                        }
                    }
                }
            }
            for (const key of Object.keys(payload)) {
                if (typeof state[key] != 'undefined' && Array.isArray(payload[key])) {
                    let objects = payload[key]
                    for (const obj of objects) {
                        let cls;
                        if (key === 'users') cls = User;
                        if (key === 'sites') cls = Site;
                        if (key === 'devices') cls = Device;
                        if (key === 'employees') cls = Employee;
                        if (key === 'teams') cls = Team;
                        if (key === 'statusmaps') cls = StatusMap;
                        if (key === 'usersiteprefs') cls = UserSitePref;
                        if (key === 'pings') cls = Ping;
                        if (key === 'manuals') cls = Manual;
                        upsert(state[key], obj, cls)
                    }
                }
            }
        },
    },
    actions: {
        addIcon(context, payload) {
            context.commit('addIcon', payload)
        },

        setLogin(context, payload) {
            context.commit('login', payload)
        },

        upsert(context, payload) {
            context.commit('upsertValues', payload)
        },

        gotoPage(context, page) {
            if (!checkAccess(context.getters.access, page)) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            context.state.ref.app.curPage = page || 'dashboard'
        },

        gotoEmployee(context, empId) {
            if (!checkAccess(context.getters.access, 'employeeStats')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            context.state.ref.app.curPage = 'employeeStats'
            context.state.ref.employeeStats.selectedEmployee = empId
        },

        gotoTeam(context, teamId) {
            if (!checkAccess(context.getters.access, 'teamStats')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            context.state.ref.app.curPage = 'teamStats'
            context.state.ref.teamStats.selectedTeam = teamId
        },

        gotoTeamSettings(context, _id) {
            if (!checkAccess(context.getters.access, 'teams')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            const team = context.getters.teamsRef[_id]
            context.state.ref.teams.selected = team
            context.state.ref.teams.filterStr = null
            context.state.ref.app.curPage = 'teams'
        },

        gotoEmployeeSettings(context, _id) {
            if (!checkAccess(context.getters.access, 'employees')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            const employee = context.getters.employeesRef[_id]
            context.state.ref.employees.selected = employee
            context.state.ref.employees.filterStr = null
            context.state.ref.employees.tabIndex = employee.disabled ? 1 : 0;
            context.state.ref.app.curPage = 'employees'
        },

        gotoDeviceSettings(context, _id) {
            if (!checkAccess(context.getters.access, 'devices')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            const device = context.getters.devicesRef[_id]
            context.state.ref.devices.selected = device
            context.state.ref.devices.filterStr = null
            context.state.ref.devices.tabIndex = device.employeeId ? (device.disabled ? 1 : 0) : 2;
            context.state.ref.app.curPage = 'devices'
        },

        gotoApp(context, appName) {
            if (!checkAccess(context.getters.access, 'classification')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            context.state.ref.app.curPage = 'classification'
            context.state.ref.classification.selected = null;
            context.state.ref.classification.tabIndex = 0;
            context.state.ref.classification.openOnStartup = appName;
        },

        gotoAppStats(context, appName) {
            if (!checkAccess(context.getters.access, 'appStats')) {
                context.state.storeEvents.emit('denied')
                return;
            }
            context.commit('addBackPage', context.getters)
            context.state.ref.app.curPage = 'appStats'
            context.state.ref.appStats.selectedApp = appName
        },

        goBack(context) {
            if (context.state) {
                const fn = context.state.backPages.pop()
                fn()
                if (!checkAccess(context.getters.access, context.state.ref.app.curPage)) {
                    context.state.storeEvents.emit('denied')
                    context.dispatch('goBack')
                }
            }
        },

        async updateSelections(context) {
            newReq('POST', 'users/updateSelections', {
                employeesSelectedColumns: context.state.ref.dashboard.employeesSelectedColumns,
                teamsSelectedColumns: context.state.ref.dashboard.teamsSelectedColumns,
                appsSelectedColumns: context.state.ref.dashboard.appsSelectedColumns,
                employeeStats: context.state.ref.employeeStats.selectedCards,
                teamStats: context.state.ref.teamStats.selectedCards,
                appStats: context.state.ref.appStats.selectedCards,
            })
                .catch(e => {
                    console.log('Error Updating Selections', e)
                })
        },

        setSiteConfig(context, payload) {
            context.commit('setSiteConfig', payload);
        },
    },
    getters: {
        pingsRef(state) {return objectifyArr(state.pings, "deviceId")},
        onlineDeviceIds(state) {
            return state.pings
                .filter(ping => {
                    return (state.curTime.getTime() - ping.lastPingDate.getTime()) < 30000
                })
                .map(ping => ping.deviceId)
        },
        icons(state) {
            return state.icons
        },
        sites(state) {
            return state.sites
        },
        signup(state) {
            return state.signup
        },
        live() {
            return process.env.NODE_ENV !== 'development'
        },
        backPages(state) {return state.backPages},
        config(state) {return [...state.config].pop()},
        loggedIn(state) {return state.loggedIn},
        user(state) {
            try {
                return state.users.filter(obj => obj._id === state.userId).pop()
            } catch (e) {
                return null
            }
        },
        users(state) {return state.users},
        usersSitePrefs(state, getters) {
            return getters.users.map((user) => {
                return state.usersiteprefs.find(pref => pref.userId === user._id) || new UserSitePref({userId: user._id})
            })
        },
        usersSitePrefsRef(state, getters) {
            return objectifyArr(getters.usersSitePrefs, 'userId')
        },
        access(state, getters) {
            try {
                return getters.usersSitePrefsRef[state.userId].access
            } catch (e) {
                return {
                    statistics: false,
                    screenshots: false,
                    setup: false,
                    classification: false,
                    billing: false,
                    users: false,
                    approvals: false,
                    leave: false
                }
            }
        },
        statusmaps(state) {return state.statusmaps},
        devices(state) {return state.devices},
        teams(state) {return state.teams},
        realTime(state) {return state.realtimes},
        connectedDevices(_, getters) {
            return getters.realTime.filter(device => device.connected)
        },
        realTimeByDeviceId(_, getters) {
            return objectifyArr(getters.realTime, "deviceId")
        },
        employees(state) {return state.employees},
        employeeMap(state) {return new Map(state.employees.map(v => [v._id, v]))},
        teamMap(state) {return new Map(state.teams.map(v => [v._id, v]))},
        usersRef(state) {return objectifyArr(state.users, "_id")},
        statusmapsRef(state) {return objectifyArr(state.statusmaps, "_id")},
        statusmapsByMatch(state) {return objectifyArr(state.statusmaps, "match")},
        devicesRef(state) {return objectifyArr(state.devices, "_id")},
        teamsRef(state) {return objectifyArr(state.teams, "_id")},
        employeesRef(state) {return objectifyArr(state.employees, "_id")},
        employeesByTeam(state) {
            return state.employees.reduce((obj, emp) => {
                const key = emp.teamId || 'null';
                if (!obj[key])
                    obj[key] = [];
                obj[key].push(emp);
                return obj
            }, {})
        },
        devicesByEmployee(state) {
            return state.devices.reduce((obj, device) => {

                if (device.userDevice)
                    return obj

                const key = device.employeeId || 'null';
                if (!obj[key])
                    obj[key] = [];
                obj[key].push(device);
                return obj
            }, {})
        },
        teamsByUser(state) {
            return state.teams.reduce((obj, team) => {
                for (const userId of (team.userIds || [])) {
                    if (!obj[userId])
                        obj[userId] = [];
                    obj[userId].push(team);
                }
                return obj
            }, {});
        },
        site(state) {
            try {
                return state.sites.filter(obj => obj._id === state.curSiteId).pop()
            } catch (e) {
                return null
            }
        },
        labels(state) {return state.labels},
        labelsRef(state) {return objectifyArr(state.labels, "id")},
        teamsWithAccess(state, getters) {
            // Check That user is placed into A team
            const activeTeams = getters.teams.reduce((list, team) => {
                if (team.userIds && team.userIds.includes(getters.user._id))
                    list.push(team)
                return list
            }, [])
            return activeTeams.length ? activeTeams : state.teams
        },
        teamWithAccessIds(_, getters) {
            return getters.teamsWithAccess.map(team => team._id)
        },
        employeesWithAccess(state, getters) {
            return state.employees.filter(employee => {
                if (!employee.teamId)
                    return true
                else
                    return getters.teamWithAccessIds.includes(employee.teamId)
            })
        },
        employeesWithAccessIds(_,getters) {
            return getters.employeesWithAccess.map(employee => employee._id)
        },
        devicesWithAccess(state, getters) {
            return state.devices.filter(device => {
                if (device.userDevice)
                    return false

                if (!device.employeeId)
                    return true
                else
                    return getters.employeesWithAccessIds.includes(device.employeeId)
            })
        },
        devicesWithAccessIds(_,getters) {
            return getters.devicesWithAccess.map(device => device._id)
        },
        approvalsWithAccess(state, getters) {
            return state.manuals.filter(manual => getters.employeesWithAccessIds.includes(manual.employeeId))
        },
        getSiteConfig(state) {
            return state.siteConfig;
        }
    }
});

export default store